import { ListItemIconProps, ListItemIcon as MuiListItemIcon } from "@mui/material";

type Props = ListItemIconProps;

export const ListItemIcon = ({ children, ...props }: Props) => {
  return <MuiListItemIcon {...props}>{children}</MuiListItemIcon>;
};
